export default theme => ({
  root: {
    width: '100%',
    height: '60px',
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: '0 30px 0 16px',
    borderBottom: `1px solid ${theme.colors.grey[100]}`
  },
  left: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    marginRight: '12px'
  },
  center: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexGrow: 1,
    '& [class*="HoiPoi__QuickFilters__right"]': {
      marginRight: 0
    }
  },
  right: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  selectAll: {
    display: 'flex',
    gap: '8px'
  },
  bulkActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  actions: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center'
  },
  saveButton: {
    width: '32px',
    height: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.grey[50]
    }
  },
  saveButtonDisabled: {
    cursor: 'not-allowed !important',
    '&:hover': {
      backgroundColor: 'transparent  !important'
    },
    '& path': {
      fill: theme.colors.grey[100]
    }
  },
  dividerFilters: {
    width: '2px',
    height: '16px',
    backgroundColor: theme.colors.grey[100],
    marginRight: '12px'
  },
  dividerActions: {
    width: '2px',
    height: '16px',
    backgroundColor: theme.colors.grey[100],
    margin: '0 12px 0 6px'
  },
  shareMenu: {
    marginRight: '12px',
    '& .rc-menu-submenu-title': {
      paddingBottom: 0
    }
  },
  shareMenuPopover: {
    zIndex: 1001
  },
  downloadMenu: {
    '& .rc-menu-submenu-title': {
      paddingBottom: '0px',
      '& > span': {
        marginRight: '0px'
      }
    }
  },
  downloadMenuPopover: {
    zIndex: 10001
  },
  excelIcon: {
    '& svg': {
      ' & path:first-of-type': {
        fill: theme.colors.actionMinor[500]
      },
      '& path:nth-of-type(3)': {
        fill: theme.colors.actionMinor[500]
      }
    }
  },
  customFiltersContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px'
  },
  customFilter: {
    height: '32px',
    padding: '7px 8px',
    backgroundColor: theme.colors.semantic.infoCustom50,
    borderRadius: '4px',
    boxSizing: 'border-box',
    '& [class*="HoiPoi__Text"]': {
      textWrapMode: 'nowrap'
    }
  }
});